// extracted by mini-css-extract-plugin
module.exports = {"why-visalex__advantages":"WhyVisalexAdvantages_why-visalex__advantages__7eRMd","why-visalex__revolutionizing":"WhyVisalexAdvantages_why-visalex__revolutionizing___d89s"};